import { Link, useLocation } from "react-router-dom";
export function Breadcrumb({ items }: { items?: Array<{ label: string; to?: string }> }) {
  const location = useLocation();
  const computed = items ?? location.pathname
    .split("/")
    .filter(Boolean)
    .map((seg, i, arr) => ({
      label: decodeURIComponent(seg),
      to: "/" + arr.slice(0, i + 1).join("/"),
    }));
  if (computed.length === 0) return null;
  return (
    <nav aria-label="Breadcrumb" className="text-sm mb-4 text-text-muted">
      <ol className="flex flex-wrap gap-1">
        <li><Link to="/" className="hover:text-primary">{"Startseite"}</Link></li>
        {computed.map((c, i) => (
          <li key={i} className="flex gap-1">
            <span>/</span>
            {c.to && i < computed.length - 1 ? (
              <Link to={c.to} className="hover:text-primary capitalize">{c.label}</Link>
            ) : (
              <span className="capitalize text-text">{c.label}</span>
            )}
          </li>
        ))}
      </ol>
    </nav>
  );
}
